import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { renderIf } from 'core/utils';
import esDefaultSvg from 'themes/img/es-default.svg';

function TableEmptyTemplate({ t, showImage, showLoader }) {
	return showLoader ? (
		<div className="grid-loader">
			<div className="spinner spinner--g"></div>
		</div>
	) : (
		<div className="w--400--px illustrate--center">
			{renderIf(showImage)(
				<img className="display--b spc--bottom--med spc--top--med" src={esDefaultSvg} />
			)}
			<p className="spc--bottom--med w--250--px align--h--center type--center">{t('LISTEMPTY.SEARCH')}</p>
		</div>
	);
}

export default defaultTemplate(TableEmptyTemplate);
